import { Assets } from '@gleamer/types';
import {
  isReadonly,
  useAssetCharacterisations,
  useTask,
  useUpdateAssetCharacterisations,
} from '@gleamer/ui';
import { ServicesManager } from '@ohif/core';
import Form, { FormProps } from '@rjsf/core';
import isEqual from 'lodash/isEqual';
import React from 'react';
import { useCurrentItem } from '../../../../hooks/useCurrentItem';
import { defaultFormValidator } from '../../../../utils/validation.utils';

type StudyAssetRef = Assets.StudyAssetRef;

type StudyCharacterisationProps = {
  StudyInstanceUID: string;
  servicesManager: ServicesManager;
};

export function StudyCharacterisation({
  StudyInstanceUID,
  servicesManager,
}: StudyCharacterisationProps) {
  const readOnly = isReadonly();
  const task = useTask();
  const current = useCurrentItem({ servicesManager });
  const characterisations = useAssetCharacterisations();
  const updateCharacterisations = useUpdateAssetCharacterisations();

  const jsonSchema = task?.characterisations?.study?.json;
  if (!jsonSchema) {
    return null;
  }

  const asset: StudyAssetRef = {
    kind: 'study',
    patientId: current.studies[0].PatientID,
    studyInstanceUID: StudyInstanceUID,
  };

  const existingCharacterisation = characterisations.find(charac =>
    isEqual(charac.asset, asset)
  );

  const handleChange: FormProps<any>['onChange'] = event => {
    if (event.errors.length > 0) {
      return;
    }

    updateCharacterisations(asset, event.formData);
  };

  if (!existingCharacterisation) {
    return null;
  }

  return (
    <div className="characterisation-panel">
      <div className="my-2 ml-2 text-white">
        <Form
          readonly={readOnly}
          schema={jsonSchema}
          onChange={handleChange}
          formData={existingCharacterisation.characterisation}
          uiSchema={{
            ...task.characterisations.study.ui,
            'ui:submitButtonOptions': {
              norender: true,
            },
          }}
          validator={defaultFormValidator}
        />
      </div>
      <hr className="my-2 border-gray-700" />
    </div>
  );
}
